import React from 'react';
import Tables from 'components/Table';
import { makeStyles } from '@material-ui/core';
import Figure from './Figure';
import {
  benchmarkFilter,
  formatName
} from 'components/Charts/Utils/benchmarks';
import { MetaType } from 'store/modules/Meta/types';

const { Table, TableRow, TableHead, TableCell } = Tables;

interface CumulativePerformanceTableProps {
  data: any;
  benchmarks?: Array<MetaType>;
}

const useStyles = makeStyles(theme => ({
  row: {
    '&:nth-child(even):not(.MuiTableRow-head)': {
      backgroundColor: '#f7f7f7'
    }
  },
  benchmarkRow: {
    color: theme.palette.primary.main
  }
}));

const DiscretePerformanceTable = ({
  data,
  benchmarks
}: CumulativePerformanceTableProps) => {
  const classes = useStyles();
  const keys = Object.keys(data || {}).filter((key: string) => key !== 'date');
  const headers = ['', '0-12m', '12-24m', '24-36m', '36-48m', '48-60m'];

  return (
    <Table>
      <TableHead cells={headers} />
      {keys.map((key: string) => {
        const isBenchmark = benchmarkFilter(
          benchmarks?.map((benchmark: any) => benchmark.name),
          key
        );
        return (
          <TableRow
            className={`${classes.row} ${isBenchmark ? classes.benchmarkRow : ''}`}
            key={key}
          >
            <TableCell>
              <span style={{ fontWeight: 700 }}>{formatName(key)}</span>
            </TableCell>
            {Object.values(headers)
              .slice(1)
              .map((item: any, index: number) => {
                const figure = data[key][`discrete_${index}_performance`] || {};
                return (
                  <TableCell key={index}>
                    <Figure
                      value={figure.value}
                      startDate={figure.startDate}
                      endDate={figure.endDate}
                    />
                  </TableCell>
                );
              })}
          </TableRow>
        );
      })}
    </Table>
  );
};

export default DiscretePerformanceTable;
